// Get the popup and buttons
const popup = document.getElementById('popup');
const showPopupBtn = document.getElementById('showPopupBtn');
const closePopupBtn = document.getElementById('closePopupBtn');

showPopupBtn.addEventListener('click', () => {
    popup.style.display = 'flex'; // Show the popup
    document.body.classList.add('no-scroll');
});

closePopupBtn.addEventListener('click', () => {
    popup.style.display = 'none';
  document.body.classList.remove('no-scroll');
});

window.addEventListener('click', (e) => {
    if (e.target === popup) {
      popup.style.display = 'none';
      document.body.classList.remove('no-scroll');
    }
});